import './FailedChecks.less';
import React, { useMemo } from 'react';
import ServiceableUrlsTable from '../serviceableUrls/table/ServiceableUrlsTable';
import useAddUrlAnalysisProcessWithNotification from '../process/hooks/useAddUrlAnalysisProcessWithNotification';
import { ServiceableUrl } from '../serviceableUrls/types';
import { Button } from 'antd';
import useFetchAffectedClusterUrlsPage from './hooks/useFetchAffectedClusterUrlsPage';
import { AffectedClustersLastEvaluatedKey } from './types';

type Props = {
    websiteGuid: string;
    clusterGuid: string;
    seoTestKey: string;
    sampleUrls: ServiceableUrl[];
    clusterLastEvaluatedKey: AffectedClustersLastEvaluatedKey | null;
    isLoadButtonDisabled?: boolean;
};

export default function AffectedUrls({ websiteGuid, clusterGuid, seoTestKey, sampleUrls, clusterLastEvaluatedKey, isLoadButtonDisabled }: Props) {
    const { addUrlAnalysisProcess, isAddingUrlAnalysisProcess } = useAddUrlAnalysisProcessWithNotification();

    const { accumulatedUrls, isFetchingAffectedUrlsNextPage, hasMore, handleLoadMore } = useFetchAffectedClusterUrlsPage({
        websiteGuid,
        clusterGuid,
        seoTestKey,
        clusterLastEvaluatedKey,
    });

    const handleCheckUrlClick = async (urlGuid: string) => {
        addUrlAnalysisProcess(websiteGuid, urlGuid);
    };

    const allUrls = useMemo(() => [...sampleUrls, ...accumulatedUrls], [accumulatedUrls, sampleUrls]);

    return (
        <>
            <ServiceableUrlsTable
                serviceableUrls={allUrls}
                urlClusters={[]}
                seoTestKey={seoTestKey}
                onCheck={handleCheckUrlClick}
                isCheckButtonLoading={isAddingUrlAnalysisProcess}
            />

            {hasMore && (
                <Button
                    className="load-more-urls"
                    type="primary"
                    size="small"
                    onClick={handleLoadMore}
                    loading={isFetchingAffectedUrlsNextPage}
                    disabled={isLoadButtonDisabled}
                >
                    Load more
                </Button>
            )}
        </>
    );
}
